import { getStore, setStore } from '../config/global';
import {
    ADD_GOODS,
    REDUCE_CART,
    CLEAR_CART,
    SET_ROUND,
} from './mutations-type';

export default {
    //1.往购物车中添加数据
    [ADD_GOODS](state, { goodsId, goodsName, smallImage, goodsPrice }) {
        let shopCart = state.shopCart;
        //  判断商品是否存在
        if (shopCart[goodsId]) { //存在
            shopCart[goodsId]['num']++;
        } else { //不存在 产生一个对象
            shopCart[goodsId] = {
                'num': 1,
                'id': goodsId,
                'name': goodsName,
                'small_image': smallImage,
                'price': goodsPrice,
                'checked': true
            }
        }
        // 产生新对象
        state.shopCart = {...shopCart };
        //  存入本地
        setStore('shopCart', state.shopCart)
    },
    // 2.把商品移除购物车
    [REDUCE_CART](state, { goodsId }) {
        let shopCart = state.shopCart;
        let goods = shopCart[goodsId]
        if (goods) {
            if (goods['num'] > 0) {
                goods['num']--;
                // 判断是否只有0个
                if (goods['num'] === 0) {
                    delete shopCart[goodsId]
                }
            } else {
                goods = null;
            }
        }
        //同步数据
        state.shopCart = {...shopCart }
        setStore('shopCart', state.shopCart)
    },
    // 3.清空购物车
    [CLEAR_CART](state) {
        state.shopCart = {}
            //同步数据
        setStore('shopCart', state.shopCart)
    },
    // 4.设置比赛轮数
    [SET_ROUND](state,round){
        state.round = round
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js